module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stock-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-freight-statuses",
      "md-label": "Статусы отслеживания груза",
      "to": {
        name: 'TrackingStatuses'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296abff0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/menu.vue
// module id = 1083
// module chunks = 0